import BodyClassName from 'react-body-classname'

type BodyClassNameProps = {
  className: string
  children?: JSX.Element
}

const BodyClass = ({ className, children }: BodyClassNameProps): JSX.Element => (
  <BodyClassName className={className}>
    <>{children}</>
  </BodyClassName>
)

export default BodyClass
